// API configuration used by all Angular services.
export const ApiConfig = {
  // Backend API base URL.
  //baseUrl: 'https://localhost:7046/api'
   //baseUrl: 'https://alphaapi.iitcglobal.net/QrGeneratorAPI/api'
  baseUrl: 'https://publicapi.ecbtraining.com.au/QrGeneratorAPI/api'
};

//Vetrack sync API url
export const SyncConfig = {
  //syncUrl: 'https://localhost:7188'
   //syncUrl: 'https://alphasyncapi.iitcglobal.net/AlphaSyncAPI'
 syncUrl: 'https://syncapi.ecbtraining.com.au/AlphaSyncAPI'
}